import { Link, type MetaFunction } from '@remix-run/react'
import { ChevronLeft } from 'lucide-react'
import { Button } from '#app/components/ui/button.js'

export const meta: MetaFunction = () => [
	{ title: "Privacy Policy | Let's Rally!" },
]

export default function PrivacyPolicy() {
	return (
		<div className="p-5 pt-12">
			<Button variant="secondary" asChild>
				<Link to="..">
					<ChevronLeft size={16} className="mr-2" /> Back
				</Link>
			</Button>
			<h1 className="text-2xl font-bold text-gray-800">
				Privacy Policy of Let's Rally
			</h1>
			<p className="text-sm text-gray-500">
				V.1 Last updated: {new Date(2024, 4, 24).toLocaleDateString()}
			</p>
			<p className="mt-4 text-gray-600">
				Welcome to Let's Rally! Your privacy is of utmost importance to us. This
				Privacy Policy describes the types of information we collect from you
				and your devices, how we use your information, and the legal bases we
				have to process your information. This policy also describes your rights
				and choices regarding your personal information, and how you can access
				and update this information. If you have additional questions or require
				more information about our Privacy Policy, do not hesitate to contact
				us.
			</p>
			<h2>Consent</h2>
			<p>
				By using our website and app, Let’s Rally and letsrally.life, you hereby
				consent to our Privacy Policy and agree to its terms.
			</p>
			<h2>Information We Collect</h2>
			<ul>
				<li>
					<strong>Personal Information</strong>
					<ul>
						<li>
							Account Information: When you create an account, we may ask for
							personal information like your name and phone number.
						</li>
						<li>
							Contact Access: If you grant us access, we collect the names,
							phone numbers, and email addresses of your contacts to enhance
							your experience by helping you connect with your friends and
							colleagues on our platform.
						</li>
					</ul>
				</li>
				<li>
					<strong>Usage and Device Information</strong>
					<ul>
						<li>
							Log Data: Includes details about how you’ve used our services,
							device information, access dates and times, app features or pages
							viewed, and other system activity.
						</li>
						<li>
							Device Information: We may collect information about the mobile
							device you use to access our services, including hardware models,
							operating system versions, unique device identifiers, and mobile
							network information.
						</li>
					</ul>
				</li>
				<li>
					<strong>Contact Information</strong>
					<ul>
						<li>
							If we are given permission to access your contacts, we may collect
							the names and phone numbers of your contacts to help you connect
							with your friends and invite them to events. We store your contact
							information securely on our servers and do not share it with third
							parties. All contact data is scrubbed and erased from our servers
							if your account is deleted.
						</li>
					</ul>
				</li>
			</ul>
			<h2>How We Use Your Information</h2>
			<p>
				We use the information we collect to: Provide, maintain, and improve our
				services; Develop new services and features; Understand and analyze how
				you use our app and what services and features you prefer; Communicate
				with you, either directly or through one of our partners, including for
				customer service, to provide you with updates and other information
				relating to the app, and for marketing and promotional purposes; Send
				you notifications; Find and prevent fraud.
			</p>
			<h2>Sharing of Your Information</h2>
			<p>
				We do not share your personal information with third parties except in
				the following cases: With your consent; For legal reasons, if sharing is
				required by law or necessary to protect the rights, property, or safety
				of Let's Rally, our users, or others; With service providers who help us
				provide our services under confidentiality agreements.
			</p>
			<h2>Your Choices and Control</h2>
			<p>
				You have control over your personal information and how it's collected,
				used, and shared. For example, you can: Access or request correction,
				updates, or deletion of your personal information; Object to processing
				of your personal information, ask us to restrict processing of your
				information or request portability of your information; Opt out of some
				data collection, such as disabling cookies or location tracking on your
				device.
			</p>
			<h2>Data Security</h2>
			<p>
				We implement security measures designed to protect your information from
				unauthorized access, alteration, disclosure, or destruction. We
				regularly monitor our systems for possible vulnerabilities and attacks.
			</p>
			<h2>Children’s Information</h2>
			<p>
				Another part of our priority is adding protection for children on the
				internet. We encourage parents and guardians to observe, participate in,
				and/or monitor and guide their online activity. Let’s Rally does not
				knowingly collect any Personal Identifiable Information from children
				under the age of 12. If you think that your child provided this kind of
				information on our website, we strongly encourage you to contact us
				immediately and we will do our best efforts to promptly remove such
				information from our records.
			</p>
			<h2>Changes to This Policy</h2>
			<p>
				We may update this privacy policy from time to time. The updated version
				will be indicated by an updated “Revised” date and the updated version
				will be effective as soon as it is accessible.
			</p>
		</div>
	)
}
